import { useProgressNoteFormContext } from "@/modules/patients/detail/progress-note/hooks/useProgressNoteFormStore"
import { useStoreFormState } from "@/modules/patients/detail/progress-note/hooks/useStoreFormState"
import { AssignEpisodeOfCareFormType } from "@/modules/patients/detail/progress-note/progress-note-card-header"

export const useAssignEpisodeOfCareForm = (id: string, icdCode: string) => {
  const progressNoteForms = useProgressNoteFormContext((state) => state.progressNoteForms)

  const storeForm = progressNoteForms.get(id)?.assignEpisodeOfCareForm

  const storeFormValue = storeForm?.getValues()

  let defaultValues: Partial<AssignEpisodeOfCareFormType>

  if (storeFormValue) {
    defaultValues = { ...storeFormValue, formIsDirty: false }
  } else {
    defaultValues = {
      icdCode,
      formIsDirty: false,
    }
  }

  const storeFormState = useStoreFormState(storeForm)

  return { defaultValues, storeFormState }
}
